import { Action, Module, VuexModule } from "vuex-module-decorators";
import { Booth } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "@/assets/ts/components";

@Module
export default class BoothModule extends VuexModule {
    @Action
    [Booth.getBoothList]() {
        return new Promise<void>((resolve, reject) => {
            ApiService.get(`/booths/list`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Booth.getList8BoothNCount]() {
        return new Promise<void>((resolve, reject) => {
            ApiService.get(`/booths/list8BoothNCount`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Booth.findPageBooth](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/booths`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Booth.saveBooth](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/booths/save`, values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Booth.deleteBooth](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/booths/delete`, values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

}